var React = require('react');

function SquaredCornersFluidInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M738 411.871V83.7223C710.384 51.0412 694.87 32.6811 667.255 0H70.7453C43.1298 32.6811 27.6155 51.0412 0 83.7223V411.871C29.0894 446.297 45.3794 465.575 74.4688 500H663.609C692.621 465.575 708.988 446.297 738 411.871Z"}));
}

SquaredCornersFluidInline.defaultProps = {"width":"738","height":"500","viewBox":"0 0 738 500","fill":"none"};

module.exports = SquaredCornersFluidInline;

SquaredCornersFluidInline.default = SquaredCornersFluidInline;
